// extracted by mini-css-extract-plugin
export default {"type":"styles_type__EhoSc","wl":"styles_wl__-dy9n","ce":"styles_ce__tDolt","vb":"styles_vb__RWA1b","mr":"styles_mr__gdtw7"};